export default __webpack_public_path__ + "static/media/deciemSVG.f9d1a512.svg";